import React, { Component } from "react";
import Routes from "../routes";

class FullWidthLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <div
        className="FullWidthLayout"
        style={{ height: "calc(100vh )", paddingTop: "64px" }}
      >
        <Routes />
      </div>
    );
  }
}
export default FullWidthLayout;
